import { Component, OnInit,ViewChild } from '@angular/core';
import { PurchaseInvoice } from 'app/shared/types/purchase-invoice';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PurchaseInvoiceService } from 'app/shared/services/purchase-invoice.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';

@Component({
  selector: 'app-purchase-return-list',
  templateUrl: './purchase-return-list.component.html',
  styleUrls: ['./purchase-return-list.component.css']
})
export class PurchaseReturnListComponent implements OnInit {

  displayedColumns: string[] = ['type','grnNo', 'grnDate', 'supplier', 'amount','status','createdBy','action'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;

  purchaseReturnList : any[] = [];
  filterefPurchaseReturnList :any[] =[];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
 

  constructor(
    private purchaseInvoiceService: PurchaseInvoiceService,
    private router : Router, 
    private route : ActivatedRoute, 
    private themeService: NbThemeService,
    private authService: AuthService,
   ) { }

ngOnInit() {

this.getAllGRN();
this.getControlPermissions();
this.themeService.onThemeChange()
.subscribe(themeName =>{
     this.isDark  = themeName.name ==='dark' ? true : false;
   });

}

getControlPermissions(){
  var data = [];
   data =  this.authService.controlPermissionArray.filter((el)=>{
    return el.moduleCode ==='PR'
  });
  if(data.length > 0){
    this.crud_access.read = data[0].read;
    this.crud_access.create = data[0].create;
    this.crud_access.approve = data[0].approve;
    this.crud_access.delete = data[0].delete;
  }
}

newButtonClick(){
this.router.navigate(['../purchase-return'],{relativeTo : this.route});
}


getAllGRN(){
this.purchaseInvoiceService.getAll()
.subscribe(
(data) => {
    this.purchaseReturnList= data;
    this.filterefPurchaseReturnList= this.purchaseReturnList.filter((el)=>{
      return el.Type ==='Debit Note';
    }); 
    this.dataSource = new  MatTableDataSource (this.filterefPurchaseReturnList);  
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;         
        },
(err) => 
      {
        if(err instanceof HttpErrorResponse){                 
          if(err.status == 401){
            this.router.navigate(['/login']);
          }
        }
        console.log(err);
      });  



}


viewDetailsButtonClick(returnNo : string){   
  this.router.navigate(['../purchase-return'],{queryParams : {'returnNo':returnNo},relativeTo : this.route}); 
}


applyFilter(){
this.dataSource.filter =this.searchKey.trim().toLowerCase();

}
onSearchClear(){
this.searchKey = "";
this.applyFilter();
}

}
